var $ = require( 'jquery' )
var jQuery = $
global.$ = $; // rendre globale (on peut l'utiliser depuis la console F12)
global.jQuery = jQuery;
require( 'bootstrap3' );
var sclbasic = require('node-scl-basic')
var cca = require('../cca');

////////////////////////////
///////////////////////////////////////////////////////////
///////////////////////////////
////////////////////////////////////////////////////////////////////
///////////////////////////
var configPublic = require('../../config.public.live.json');
//////////

var tcfExamTypeMap = configPublic.tcf_exam_type_map || {};

// Timestamp sentinelle pour "SUR DEMANDE" : 19/01/2038 (max int32 ~2147483647)
var SUR_DEMANDE_TS = 2147400000;

// Colonne "Date d'examen" → "SUR DEMANDE" si sentinelle
var _origDateExamDisplay = sclbasic.displayList.fieldObject_dispatcher['date_exam'].getDisplayValue;
sclbasic.displayList.fieldObject_dispatcher['date_exam'].getDisplayValue = function(rowdata) {
    if (rowdata['date_exam'] >= SUR_DEMANDE_TS) { return 'SUR DEMANDE'; }
    return _origDateExamDisplay.call(this, rowdata);
};

// Colonne "Date limite d'inscription" → vide si sentinelle
var _origDateLimiteDisplay = sclbasic.displayList.fieldObject_dispatcher['date_limite_inscription'].getDisplayValue;
sclbasic.displayList.fieldObject_dispatcher['date_limite_inscription'].getDisplayValue = function(rowdata) {
    if (rowdata['date_exam'] >= SUR_DEMANDE_TS) { return ''; }
    return _origDateLimiteDisplay.call(this, rowdata);
};

// Override button URL: TCF index links to /tcf-form with exam_type param.
// cca.js registers serviceCCAWebObj in fieldObject_dispatcher on require —
// overriding getDisplayHtml here affects the dispatcher via the same reference.
cca.serviceCCAWebObj.getDisplayHtml = function(rowdata) {
    var examType = tcfExamTypeMap[rowdata['produit_info_id']] || '';
    var formUrl = BASE_PATH + '/tcf-form?exam_type=' + examType;
    var params = sclbasic.util.parseQueryString(window.location.search);
    if (params['fillForm'] === 'dummydata') {
        formUrl += '&fillForm=dummydata';
    }
    var html = cca.serviceCCAWebObj.getDisplayHtmlParametrized(rowdata, formUrl);
    // Si date_exam = 19/01/2038 (sentinelle), remplacer la date par "SUR DEMANDE"
    if (rowdata['date_exam'] >= SUR_DEMANDE_TS) {
        var dateStr = sclbasic.util.intToDatetime(rowdata['date_exam']);
        html = html.split(dateStr).join('SUR DEMANDE');
    }
    return html;
};

function run(){
    $( document ).ready( function () {

        var params = sclbasic.util.parseQueryString(window.location.search);
        if (params['fillForm'] === 'dummydata') {
            $('<div style="background:#f0ad4e;color:#000;text-align:center;padding:8px 16px;font-weight:bold;position:sticky;top:0;z-index:9999;">⚠ TEST MODE — form will be pre-filled with dummy data</div>')
                .prependTo('body');
        }

        $.ajax({
            type: 'GET',
            url: BASE_PATH + '/proxy/tcf-feed?pretty',
            contentType: 'text/plain',
            beforeSend: function () {
                $('#divAjaxLoader').show();
            },
            complete: function(){
                $('#divAjaxLoader').hide();
            },
            error: function(){
                alert('Erreur Affichage');
                $('#divAjaxLoader').text('Erreur Affichage');
            },
            success: function(dataReceived){
                var sessions = dataReceived.exam_cca || [];
                // Render groups are derived from the per-env tcf_exam_type_map so
                // that dev / aurora-infra / production each use their own
                // produit_info_ids without editing this file. The table id
                // convention is exam_<exam_type> (e.g. tcf_qc -> exam_tcf_qc),
                // matching the <table> ids declared in views/tcf-index.ejs.
                var groupOrder = Object.keys(tcfExamTypeMap).map(function(produitInfoId) {
                    return { key: produitInfoId, tableId: 'exam_' + tcfExamTypeMap[produitInfoId] };
                });
                groupOrder.forEach(function(group) {
                    var filtered = sessions.filter(function(s) {
                        return s.produit_info_id === group.key;
                    });
                    var data = {};
                    data[group.tableId] = filtered;
                    sclbasic.displayList.displayList(
                        $('#' + group.tableId),
                        { uriOptions: { q: group.tableId }, data: data }
                    );
                });
                $('td[title="modalite_exam"], td[title="modalites_exam"]').each(function() {
                    var val = $(this).text().trim();
                    if (val === 'Paper Based' || val === 'PB') {
                        $(this).html('📋 Sur Papier');
                    } else if (val === 'Computer Based' || val === 'CB') {
                        $(this).html('💻 Sur Ordinateur');
                    }
                });
            }
        });

    });
}

module.exports = {
    run: run
};
